import {
  AlertBanner,
  fetchGraphQL as fetchGraphQLCommon,
  uploadFileGraphQL as uploadFileGraphQLCommon,
  type FetchGraphQLOptions
} from "@kivunova/kivufrontendcommon";

import { captureAppException } from "../Utils/appLogger";
import { withClarityApiTracking } from "../analytics/trackClarityApi";

// Wrapper: error logging + Clarity API success/failure tracking for all GraphQL flows
export const fetchGraphQL = async <T, E>(
  query: string,
  variables: E,
  setAlert: (alert: AlertBanner) => void,
  options?: FetchGraphQLOptions
): Promise<T> => {
  return withClarityApiTracking(query, () =>
    fetchGraphQLCommon(query, variables, setAlert, captureAppException, options)
  );
};

export const uploadFileGraphQL = async <T, E>(
  query: string,
  variables: E,
  file: File,
  setAlert: (alert: AlertBanner) => void
): Promise<T> => {
  return withClarityApiTracking(
    query,
    () =>
      uploadFileGraphQLCommon(
        query,
        variables,
        file,
        setAlert,
        captureAppException
      ),
    { kindOverride: "upload" }
  );
};
